// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media only screen and (min-width: 1121px){.view-chat .chat[data-v-7ca91044],.view-chat .chat-placeholder[data-v-7ca91044]{margin:0 auto;max-width:650px;box-shadow:0 0 56px 0 rgba(0,0,0,.34)}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
